import { DELETE_FILTER } from '../../constants';

const initialState = {
  data: null,
  loading: false,
  error: {},
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case DELETE_FILTER.LOAD:
      return {
        ...state,
        loading: true,
      };
    case DELETE_FILTER.SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false,
      };
    case DELETE_FILTER.FAIL:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    default:
      return state;
  }
}
